<style lang="scss">
// Timeslot
.app-timeslot {
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: var(--theme-shadow) !important;
  }
}

.timeslot-empty {
  &.is_core:before {
    display: center;
    text-align: center;
    text-transform: uppercase;
    font-size: 9px;
    opacity: 0.8;
    line-height: 1;
    content: attr(data-timeslot);
  }

  &.not-available {
    background-color: #a0a4b0;
    pointer-events: none;
    cursor: not-allowed;
  }
}

.timeslot-filled {
  background-color: var(--theme-grey-bg);

  .customer-enter {
    font-size: 10px;
    padding: 3px 5px;
    border-radius: 5px;
    color: black;
    background: white;
    border: 1px black solid;
    transition: 0.3s;

    &:hover {
      background: black;
      color: white;
    }
  }

  .timeslot-wrapper {
    .timeslot-doctor-name {
      font-weight: bold;
      font-size: 125%;
    }

    .timeslot-name-container {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-self: flex-start;
      gap: 5px;
      margin-bottom: 5px;

      h6 {
        flex-grow: 1;
        margin: 0;
      }
    }

    // Photo Column
    .photo-col {
      flex: 0 0 30px;
      padding: 0;

      .customer-photo {
        width: 30px;
        height: 30px;
        border-radius: 15px;
        object-fit: cover;
      }
    }

    .col.content-col {
      padding: 5px;

      h6 {
        font-size: 13px;
        font-weight: bold;
        color: var(--theme-text-color);
      }

      p {
        font-size: 12px;
        line-height: 12.7px;
        color: var(--theme-text-color);
      }
    }

    .icons-col {
      overflow: hidden;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;

      &>* {
        margin: 2px;
      }

      .icon-gone {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 12px;
        border: 1px var(--theme-text-color) solid;
        background-color: white;

        i {
          font-size: 10px;
          color: var(--theme-text-color);
        }
      }

      .icon-confirmed {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 12px;
        border: 1px white solid;
        background-color: var(--theme-color-attended);

        i {
          font-size: 10px;
          color: white;
        }


        &.danger {
          background-color: var(--theme-color-absent);
        }

        &.warning {
          background-color: var(--theme-color-urgent);
        }
      }


    }
  }

  &.arrived {
    background-color: var(--theme-color-arrived);

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.attended {
    background-color: var(--theme-color-attended);

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.cancel {
    background-color: var(--theme-color-canceled) !important;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.absent {
    background-color: var(--theme-color-absent);

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.treated {
    background-color: var(--theme-color-treated);

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.gone {
    background-color: var(--theme-color-gone);

    .timeslot-wrapper {
      opacity: 0.5;
    }
  }

  &.revision {
    background-color: var(--theme-color-revision) !important;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.urgent {
    background-color: var(--theme-color-urgent) !important;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.insurance {
    background-color: var(--theme-color-insurance);

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.marked {
    background-color: var(--theme-color-marked);

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }
}
</style>

<template>
  <td @click="cellClick" @contextmenu="contextMenu" :style="cell_style" class="app-timeslot timeslot-empty"
    :data-timeslot="timeslot_name" :class="cell_class" v-if="!is_filled" :id="timeslot_id">
    <b-popover :show.sync="show_popover" :target="timeslot_id" :title="timeslot_popover_title" triggers="none"
      placement="right">

      <button @click="configureTimeslot" type="button" class="btn btn-block btn-primary btn-wabident-round xsmall">
        Configurar ...
      </button>

      <button @click="copyTimeslot" type="button" class="btn btn-block btn-primary btn-wabident-round xsmall">
        Copiar
      </button>

      <button @click="pasteTimeslot" type="button" class="btn btn-block btn-primary btn-wabident-round xsmall mb-2">
        Pegar
      </button>

      <button @click="show_popover = false" type="button" class="btn btn-block btn-primary btn-wabident-round xsmall">
        Cerrar
      </button>
    </b-popover>
  </td>
  <td :id="timeslot_id" @click="cellClick" @contextmenu="contextMenu" :style="cell_style"
    class="app-timeslot timeslot-filled" :class="cell_class" v-else-if="is_first" :rowspan="appointment_num_slots">
    <div class="timeslot-wrapper text-left row no-gutters">

      <div class="col content-col">

        <div class="timeslot-name-container">
          <!-- PHOTO -->
          <div v-if="has_photo" class="col photo-col">
            <img loading="lazy" :style="{
              transform: `rotate(${appointment.customer.photo_rotate}deg)`,
            }" class="customer-photo" :src="`/customer/${appointment.customer.id}/thumbnail`" />
          </div>
          <!-- NAME -->
          <h6 v-if="appointment.customer">
            {{ appointment.customer.full_name }}
            &nbsp;
            <i v-if="customer_can_enter" @click.stop="customerEnters" class="customer-enter fa fa-sign-in-alt"
              aria-hidden="true"></i>
          </h6>
          <h6 v-else>NOTA:</h6>
        </div>


        <p class="mb-1" v-if="show_phone">{{ appointment.customer.phone }}</p>
        <p class="mb-1" v-if="show_box">{{ box_name }}</p>
        <p class="mb-1">
          <small v-if="show_nick && default_doctor">
            <b>( {{ default_doctor.nickname }} )</b>
          </small>
          <span v-else-if="doctor">
            {{ doctor.name }}
          </span>
        </p>
        <p class="mb-1">{{ notes }}</p>
      </div>
      <div v-if="appointment.customer" class="col-12 icons-col">
        <div class="icon-gone" v-if="appointment.status == 'pending' && is_core" data-trigger="tooltip"
          title="Pendiente">
          <i class="fas fa-clock"></i>
        </div>

        <div class="icon-confirmed" v-if="appointment.status == 'confirmed' && is_core" data-trigger="tooltip"
          title="Confirmada">
          <i class="fas fa-thumbs-up"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'arrived' && is_core" data-trigger="tooltip" title="Llegó">
          <i class="fas fa-users"></i>
        </div>

        <img v-if="appointment.status == 'attended' && !is_core" src="/images/atendido.svg" />

        <div class="icon-gone" v-if="appointment.status == 'attended' && is_core" data-trigger="tooltip"
          title="Saliendo">
          <i class="fas fa-plus"></i>
        </div>

        <img v-if="appointment.status == 'treated' && is_core" src="/images/atendido.svg" />

        <div class="icon-gone" v-if="appointment.status == 'gone'" data-trigger="tooltip" title="Se fue">
          <i class="fas fa-door-open"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'cancel'" data-trigger="tooltip" title="Cancelada">
          <i class="fas fa-times"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'absent'" data-trigger="tooltip" title="No acude/No avisa">
          <i class="fas fa-times"></i>
        </div>

        <div class="icon-gone" v-if="appointment.customer && !appointment.customer.has_paid" data-toggle="tooltip"
          data-trigger="hover" title="Pagos pendientes">
          <i class="fas fa-money-bill-alt"></i>
        </div>

        <div class="icon-confirmed danger" v-if="appointment.customer && !appointment.customer.is_consent_signed"
          data-toggle="tooltip" data-trigger="hover" title="Debe firmar consentimiento">
          <i class="fas fa-edit"></i>
        </div>

        <template v-for="(section, i) in customer_history">
          <template v-for="(item, j) in section">
            <img v-if="history_icons[j] && section[j]" :key="i + '_' + j" alt="j" :src="history_icons[j]"
              data-toggle="tooltip" data-trigger="hover" :title="j" />
          </template>
        </template>

        <div class="icon-confirmed warning" v-if="show_notes || show_next_app" :id="'customer_notes_' + appointment.id"
          type="button">
          <i class="fas fa-exclamation-triangle"></i>
        </div>

        <b-popover v-if="show_notes || show_next_app" :target="'customer_notes_' + appointment.id" triggers="hover"
          placement="righttop">
          <template #title>{{ appointment.customer.full_name }}</template>
          <div v-if="show_notes">
            {{ appointment.customer.notes }}
            <hr />
            <div v-for="(section, name) in filtered_customer_history" :key="name">
              <small><strong>{{ name }}: </strong></small>
              {{ section }}
            </div>
          </div>
          <div v-if="show_next_app">
            <strong class="my=2">PROXIMA CITA</strong><br />
            <small v-if="next_app_date"><strong>Fecha (aprox):</strong> {{ next_app_date }}<br /></small>
            <small v-if="next_app_doctor"><strong>Doctor:</strong> {{ next_app_doctor }}<br /></small>
            <small v-if="next_app_notes"><strong>Notas:</strong> {{ next_app_notes }}<br /></small>
          </div>
        </b-popover>
      </div>
    </div>
  </td>
  <td :id="timeslot_id" @click="cellClick" @contextmenu="contextMenu" :style="cell_style"
    class="app-timeslot timeslot-filled" :class="cell_class" v-else-if="is_segmented_tail"></td>
  <span style="display: none" v-else> </span>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "appointment",
    "timeslot",
    "tsindex",
    "num_boxes",
    "box",
    "doctors",
    "available",
    "schedule",
  ],
  data() {
    return {
      show_popover: false,
      history_icons: {
        penicillin: "/images/penicilina.svg",
        latex: "/images/latex.svg",
        hiv: "/images/vih.svg",
        hepatitis: "/images/hepatitis.svg",
        heart_condition: "/images/cardiacos.svg",
        diabetes: "/images/diabetes.svg",
      },
    };
  },
  computed: {
    appointment_num_slots() {
      if (!this.appointment) {
        return 1;
      }
      return Math.min(this.appointment.num_slots, this.timeslot.max_slots);
    },
    timeslot_popover_title() {
      if (this.is_filled) {
        return "Cita";
      }

      return this.timeslot.name;
    },
    timeslot_id() {
      return `${this.box.id}_${this.timeslot.hour}_${this.timeslot.minute}`;
    },
    show_nick() {
      return this.clinic && this.clinic.config.agenda_timeslot_show_nick;
    },
    show_phone() {
      return (
        this.appointment &&
        this.appointment.customer &&
        this.clinic &&
        this.clinic.config.agenda_timeslot_show_phone
      );
    },
    show_box() {
      return (
        this.appointment &&
        this.appointment.customer &&
        this.clinic &&
        this.clinic.config.agenda_timeslot_show_box
      );
    },
    box_name() {
      if (this.appointment.box_id && this.clinic && this.clinic.box_names) {
        return this.clinic.box_names[this.appointment.box_id];
      } else {
        return "";
      }
    },
    show_next_app() {
      return (
        this.is_core &&
        (this.next_app_date || this.next_app_notes || this.next_app_duration)
      );
    },
    next_app_date() {
      if (
        !this.appointment ||
        !this.appointment.next_app_data ||
        !this.appointment.next_app_data.date_from
      ) {
        return null;
      }
      return moment(this.appointment.next_app_data.date_from).format(
        "DD/MM/YYYY HH:mm"
      );
    },
    next_app_notes() {
      if (
        !this.appointment ||
        !this.appointment.next_app_data ||
        !this.appointment.next_app_data.notes
      ) {
        return null;
      }
      return this.appointment.next_app_data.notes;
    },
    next_app_doctor() {
      if (
        !this.appointment ||
        !this.appointment.next_app_data ||
        !this.appointment.next_app_data.doctor_id
      ) {
        return null;
      }
      let doctor_id = this.appointment.next_app_data.doctor_id;
      let doc = this.doctors[doctor_id] || null;
      if (doc) {
        return doc.name;
      }
      return null;
    },
    show_notes() {
      return this.appointment.customer && this.appointment.customer.notes;
    },
    customer_can_enter() {
      if (!this.appointment.customer) return false;

      return (
        this.appointment.status == "pending" ||
        this.appointment.status == "confirmed"
      );
    },
    doctor() {
      if (!this.doctors || !this.appointment) return null;
      return this.doctors[this.appointment.doctor_id] || null;
    },
    default_doctor() {
      if (!this.doctors || !this.appointment) return null;
      if (!this.appointment.customer) return null;
      return this.doctors[this.appointment.customer.doctor_id] || null;
    },
    product_category() {
      if (!this.clinic || !this.clinic.product_categories_dict) {
        return null;
      }

      const pdict = this.clinic.product_categories_dict;
      const tsconfig = this.timeslot_config;

      if (!tsconfig) {
        return null;
      }

      return pdict[tsconfig.product_category_id] || null;
    },
    filtered_customer_history() {
      const section_translations = {
        allergies: "Alergias",
        diseases: "Enfermedades",
        background: "Antecedentes",
        habits: "Habitos",
      };

      let ret = {};

      for (const section_name in this.customer_history) {
        let n = section_translations[section_name] || null;
        if (n) {
          ret[n] = this.filterCustomerHistory(
            this.customer_history[section_name]
          );
        }
      }

      return ret;
    },
    customer_history() {
      if (!this.appointment.customer) return [];
      return this.appointment.customer.history;
    },
    has_photo() {
      return !(
        this.appointment.customer == null ||
        this.appointment.customer.photo == null ||
        this.appointment.customer.photo == ""
      );
    },
    app_color() {
      if (!this.appointment) {
        return null;
      }

      if (
        this.appointment.color &&
        this.appointment.color !== "null" &&
        this.appointment.color !== "#000000"
      ) {
        return this.appointment.color;
      }

      let dcolor = this.doc_color;
      if (dcolor) {
        return dcolor;
      }

      if (this.appointment.treatments.length > 0) {
        let tcolor = this.appointment.treatments[0].product.color;
        if (tcolor && tcolor !== "null" && tcolor !== "#000000") {
          return tcolor;
        }
      }

      return null;
    },
    notes() {
      let ret = [];

      if (this.appointment) {
        if (this.appointment.is_first) {
          ret.push("1ª Cita");

          if (this.appointment.product_category_id) {
            const cat = this.clinic.product_categories_dict[this.appointment.product_category_id];
            if (cat) {
              ret.push(cat.name);
            }
          }
        }

        let treatment_notes = [];

        this.appointment.treatments.forEach((t) => {
          let postfix = "";
          if (t.limit_sessions) {
            postfix = `(${t.sessions_done}/${t.max_sessions})`;
          }

          treatment_notes.push(t.full_name + postfix);
        });

        let treatment_notes_text = treatment_notes.join(' - ');
        if (treatment_notes_text.length > 50) {
          treatment_notes_text = treatment_notes_text.substring(0, 50) + '...';
        }
        ret.push(treatment_notes_text);

        if (this.appointment.notes && this.appointment.notes != "") {
          ret.push(this.appointment.notes);
        }
      }

      return ret.join(" - ");
    },
    doc_color() {
      if (!this.doctor) {
        return null;
      }

      let dcolor = this.doctor.color;
      if (dcolor && dcolor !== "null" && dcolor !== "#000000") {
        return dcolor;
      }

      if (this.default_doctor) {
        dcolor = this.default_doctor.color;
        if (dcolor && dcolor !== "null" && dcolor !== "#000000") {
          return dcolor;
        }
      }

      return null;
    },
    cell_style() {
      let width = "100%;";
      if (this.num_boxes > 0) {
        let w = 100 / this.num_boxes;
        width = `${w}%`;
      }

      let ret = {
        width: width,
      };

      if (this.is_waiting) {
        ret["background-color"] = this.app_color;
      } else if (this.clinic.config.agenda_timeslot_conserve_color && this.is_gone) {
        ret["background-color"] = this.app_color;
      }

      if (!this.is_filled && this.timeslot_config && this.product_category) {
        const color = this.product_category.color;
        if (color && color != "#000000" && color != "#00000000") {
          ret["background-color"] = window.WabiDent.hexToRGBA(color, 0.25);
          ret["color"] = "var(--theme-text-color)";
        }
      }

      return ret;
    },
    cell_class() {
      let ret = {};
      if (this.is_filled) {
        let classname = null;

        if (this.appointment.is_marked) {
          classname = "marked";
        } else if (this.appointment.is_urgent) {
          classname = "urgent";
        } else if (this.appointment.is_revision) {
          classname = "revision";
        } else if (this.appointment.is_insurance) {
          classname = "insurance";
        }

        if (this.appointment.status != "pending") {
          classname = this.appointment.status;
        }

        if (classname) {
          ret[classname] = true;
        }
      }

      ret["is_core"] = this.is_core;
      ret["not-available"] = !this.available;

      return ret;
    },
    timeslot_config() {
      if (!this.schedule) {
        return null;
      }

      const timeslot_config = this.schedule.timeslot_config || null;
      if (!timeslot_config) {
        return null;
      }

      const day = moment(this.timeslot.from).day();
      const key = `${day}:${this.timeslot.hour}:${this.timeslot.minute}:${this.box.id}`;
      const ret = timeslot_config[key] || null;

      return ret;
    },
    timeslot_name() {
      const tsconfig = this.timeslot_config;
      if (tsconfig) {
        return this.timeslot.name + " - " + tsconfig.notes;
      }

      return this.timeslot.name;
    },
    is_filled() {
      return this.appointment != null;
    },
    is_waiting() {
      return this.appointment != null && (this.appointment.status == "pending" || this.appointment.status == 'confirmed');
    },
    is_gone() {
      return this.appointment != null && this.appointment.status == "gone";
    },
    is_segmented_tail() {
      if (this.appointment.num_slots == this.appointment.total_slots) {
        return false;
      }

      const current_slot = this.getCurrentSlot();
      return current_slot >= this.appointment.num_slots;
    },
    is_first() {
      if (this.tsindex == 0) {
        return true;
      }

      let d = moment(this.appointment.date_from);
      return (
        d.minutes() == this.timeslot.minute && d.hours() == this.timeslot.hour
      );
    },
    ...mapGetters(["clinic", "is_core"]),
  },
  methods: {
    filterCustomerHistory(section) {
      let ret = [];
      const translationTable = {
        penicillin: "Penicilina",
        latex: "Látex",
        hepatitis: "Hepatitis",
        diabetes: "Diabetes",
        hiv: "HIV",
        heart_condition: "Enf. Card.",
        headache: "Cefalea",
        neuralgia: "Neuralgia",
        bruxism: "Bruxismo",
        tobacco: "Tabaco",
        alcohol: "Alcohol",
        drugs: "Drogas",
      };

      for (const key in section) {
        const translation = translationTable[key];
        const value = section[key];

        if (!value) continue;

        if (translation) {
          ret.push(translation);
          continue;
        }

        if (Array.isArray(value)) {
          ret.push(value.join(","));
          continue;
        }

        if (value && value.constructor === Object) {
          for (const subkey in value) {
            const subvalue = value[subkey];
            const subtrans = translationTable[subkey];
            if (!subvalue) continue;
            if (subtrans) {
              ret.push(subtrans);
            }
          }
        }
      }

      return ret.join(", ");
    },
    customerEnters(ev) {
      this.$emit("customerEnters", this.appointment, this.timeslot, this.box);
    },

    getCurrentSlot() {
      const range = moment.range(
        this.appointment.date_from,
        this.timeslot.from
      );
      const range_minutes = Array.from(range.by("minutes")).length - 1;
      const range_slot = Math.floor(
        range_minutes / this.appointment.slot_minutes
      );

      return range_slot;
    },

    cellClick() {
      this.$emit("cellClick", this.appointment, this.timeslot, this.box);
    },
    contextMenu(e) {
      this.$emit("contextMenu", this.appointment, this.timeslot, this.box);
      if (!this.is_filled) {
        this.show_popover = true;
      }
      e.preventDefault();
    },
    pasteTimeslot() {
      if (this.show_popover) {
        this.$emit(
          "paste",
          this.appointment,
          this.timeslot,
          this.box,
          this.timeslot_config
        );
        this.show_popover = false;
      }
    },
    copyTimeslot() {
      if (this.show_popover) {
        this.$emit(
          "copy",
          this.appointment,
          this.timeslot,
          this.box,
          this.timeslot_config
        );
        this.show_popover = false;
      }
    },
    configureTimeslot() {
      if (this.show_popover) {
        this.$emit(
          "configure",
          this.appointment,
          this.timeslot,
          this.box,
          this.timeslot_config
        );
        this.show_popover = false;
      }
    },
  },
  mounted() { },
};
</script>
